import * as types from "../actions/actionTypes";
import createEntityReducer from "./createEntityReducer";

export default createEntityReducer({
  entity: "fabricoption",
  listKey: "options",
  itemKey: "option",
  getAll: types.GET_ALL_FABRIC_OPTIONS,
  getAllResponse: types.GET_ALL_FABRIC_OPTIONS_RESPONSE,
  getByIdResponse: types.GET_FABRIC_OPTION_BY_ID_RESPONSE,
});
